/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react"
import {
  TextInput,
  TextInputProps as MantineTextInputProps,
  PillGroup,
  Pill,
} from "@mantine/core"
import { TextFieldProps as MUITextFieldProps } from "@mui/material"
import cx from "classnames"
import { getWindow } from "utils-lib/getWindow"
import withMappedProps from "hoc-lib/propsMapping"
import styles from "./TextField.mantine.module.scss"

export const MantineTextField = TextInput

export default MantineTextField

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
const ssrWindow: any = getWindow()

const muiToMantine = (
  props: MUITextFieldProps,
  handleRef?: boolean,
  ref?: any,
): MantineTextInputProps => {
  const anyProps = props as any
  return {
    ...props,
    ...props.inputProps,
    defaultValue: anyProps.defaultValue,
    value: anyProps.value ?? anyProps?.inputProps?.value,
    unstyled: true,
    onChange: (e) => {
      if (props.onChange) {
        props.onChange(e)
      }
      if (props.inputProps?.onChange) {
        props.inputProps.onChange(e)
      }
      const label = ssrWindow.document.getElementById(`${e.target.id}-label`)
      if (label) {
        e.target.value || anyProps?.chips.values?.length > 0
          ? label.classList.add(styles.labelActive)
          : label.classList.remove(styles.labelActive)(
              e.target.value || anyProps?.chips.values?.length > 0,
            )
          ? label.parentNode.classList.add(styles.valued)
          : label.parentNode.classList.remove(styles.valued)
      }
    },
    onBlur: (e) => {
      if (props.onBlur) {
        props.onBlur(e)
      }
      if (props.inputProps?.onBlur) {
        props.inputProps.onBlur(e)
      }
      const label = ssrWindow.document.getElementById(`${e.target.id}-label`)
      if (label) {
        e.target.value || anyProps?.chips.values?.length > 0
          ? label.classList.add(styles.labelActive)
          : label.classList.remove(styles.labelActive)(
              e.target.value || anyProps?.chips.values?.length > 0,
            )
          ? label.parentNode.classList.add(styles.valued)
          : label.parentNode.classList.remove(styles.valued)
      }
    },
    inputWrapperOrder: ["label", "input", "error", "description"],
    inputContainer: (children) => (
      <div className={styles.wrapper}>
        {anyProps.chips ? (
          <PillGroup className={styles.pillGroup}>
            {anyProps.chips.values.map((chip: any) => (
              <Pill
                {...anyProps.chips.ChipProps}
                key={chip.value}
                withRemoveButton
                onRemove={chip?.onRemove}
                classNames={{
                  label: styles.pillLabel,
                  remove: styles.pillRemove,
                }}
                className={styles.pill}
              >
                {chip.value}
              </Pill>
            ))}
            {children}
          </PillGroup>
        ) : (
          <>{children}</>
        )}
        <fieldset className={styles.border}>
          <legend>
            <span>{props.label ?? ""}</span>
          </legend>
        </fieldset>
      </div>
    ),
    classNames: {
      input: styles.input,
      label: cx(
        styles.label,
        anyProps.chips?.values?.length > 0 && styles.labelActive,
      ),
      error: styles.error,
      root: cx(
        styles.root,
        props.disabled && styles.disabled,
        props.error && styles.errored,
        props.fullWidth && styles.fullWidth,
        props.variant === "filled" && styles["variant-filled"],
        props.size === "small" && styles["size-small"],
        props.size === "medium" && styles["size-medium"],
      ),
      wrapper: styles.innerWrapper,
      section: styles.section,
      description: styles.description,
    },
    error: props.error ? props.helperText : undefined,
    description: !props.error ? props.helperText : undefined,
    labelProps: { ...props.InputLabelProps },
    leftSection: props.InputProps?.startAdornment,
    leftSectionPointerEvents: "none",
    rightSection: props.InputProps?.endAdornment,
    rightSectionPointerEvents: "all",
    wrapperProps: {
      ref,
    },
  }
}

export const MUIMappedTextField = withMappedProps(
  MantineTextField,
  muiToMantine,
  true,
)
